import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { SalaahTimesSection } from '../features/salaahTimes';
import DonorsInfoButton from '../components/DonorsInfoButton';

const MasjidPage: React.FC = () => {
  return (
    <>
      <main className="min-vh-100">
        <section className="masjid-section py-5">
          <div className="container py-4 py-md-5 px-3 px-md-0">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                <span className="section-eyebrow">Masjid</span>
                <h1 className="section-title mt-2 mb-3">Our Masjid</h1>
                <p className="lead text-muted mb-4">
                  Welcome to Bothasig Muslim Cultural Society! We are a vibrant community dedicated to celebrating our rich heritage and sharing our values. Our mission is to bring people together through cultural events, educational programs, and support for one another.
                </p>
                <p className="text-muted mb-4">
                  Your support is crucial in helping us achieve our goal. Every contribution, big or small, makes a difference. Together, we can create a welcoming space for everyone, promote understanding, and uplift our community. Join us in this exciting journey!
                </p>
                <div className="masjid-visual mb-4 mb-lg-0 d-inline-block">
                  <ul className="masjid-features list-unstyled mb-0">
                    <li><i className="bi bi-check2-circle text-primary me-2"></i>Daily prayers</li>
                    <li><i className="bi bi-check2-circle text-primary me-2"></i>Jumuah lecture &amp; salaah</li>
                    <li><i className="bi bi-check2-circle text-primary me-2"></i>Air conditioning &amp; parking</li>
                    <li><i className="bi bi-check2-circle text-primary me-2"></i>Wheelchair access</li>
                  </ul>
                </div>
                <div className="mt-4 d-flex gap-3 flex-wrap">
                  <Link to="/contact" className="btn btn-primary btn-lg rounded-pill">
                    <i className="bi bi-geo-alt me-2"></i>Get in Touch
                  </Link>
                  <Link to="/timeline" className="btn btn-outline-primary btn-lg rounded-pill">
                    <i className="bi bi-clock-history me-2"></i>View Our History
                  </Link>
                  <DonorsInfoButton variant="inline" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Salaah Times Section */}
        <SalaahTimesSection />
      </main>
      <Footer />
    </>
  );
};

export default MasjidPage;
